import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { SEND_TRAINER_MESSAGE } from "queries/mutations";
import useMakeScrollable from "custom_hooks/make-scrollable";
import backArrow from '../../assets/images/left_arrow.png';

const MessageToTrainer = () => {
  useMakeScrollable()
  const location = useLocation();
  const { trainerId } = location.state || {};
  const history = useHistory();
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  const [sendTrainerMessage] = useMutation(SEND_TRAINER_MESSAGE, {
    onCompleted: (response) => {
      const isSuccess = response?.sendTrainerMessage
      if (isSuccess) {
        history.push({
          pathname: '/thank-you',
          state: {
            title: "Vielen Dank für deine Nachricht!",
            text: "Unsere Referentin wird sich per Mail bei dir melden."
          }
        });
      }
    },
    onError: (data) => {
      console.log("error", data);
    },
  });


  const handleButtonClick = () => {
    sendTrainerMessage({ variables: { trainerId, subject, message } });
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className='trainer-message scrollable'>
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
      />
      <div className="trainer-message-info">
        <div>Dein Betreff</div>
        <input value={subject} onChange={handleSubjectChange} />
      </div>
      <div className="trainer-message-note">
        <div>Deine Nachricht</div>
        <textarea onChange={handleMessageChange}></textarea>
      </div>
      <button 
        className="trainer-message-button"
        onClick={handleButtonClick}
      >
        Nachricht abschicken
      </button>
    </div>
  );
};

export default MessageToTrainer;
